(() => {
  const header = document.querySelector('page-header');
  const mainSearch = document.querySelector('.pageheader .main-search');
  const announcement = document.querySelector('.announcement-wrapper');
  
  if (!header || !announcement) return;
  
  if (window.getComputedStyle(header).position === 'static') {
    header.style.position = 'relative';
  }
  
  let lastScrollTop = 0;
  
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop < lastScrollTop) {
      announcement.classList.remove('announcement-wrapper--hidden');
      announcement.classList.add('sticky');
      
      if (window.innerWidth <= 768) {
        header.style.top = '33px';
        mainSearch.style.top = '33px';
      } else {
        header.style.top = '35px';
        mainSearch.style.top = '35px';
      }
    } else if (scrollTop > lastScrollTop && scrollTop > 50) {
      announcement.classList.add('announcement-wrapper--hidden');
      announcement.classList.remove('sticky');
      header.style.top = '0';
      mainSearch.style.top = '0';
    }
    
    if (scrollTop === 0) {
      announcement.classList.remove('announcement-wrapper--hidden');
      announcement.classList.add('sticky');
      if (window.innerWidth <= 768) {
        header.style.top = '33px';
        mainSearch.style.top = '33px';
      } else {
        header.style.top = '35px';
        mainSearch.style.top = '35px';
      }
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  };
  
  window.addEventListener('scroll', handleScroll);
  handleScroll();
})();